import { useEffect, useState } from "react";
import { api_host } from "../common/globals/constants";

export function usePasosObjetivo({ objetivoId }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (objetivoId) {
      fetchPasosObjetivo();
    }
  }, [objetivoId]);

  async function fetchPasosObjetivo() {
    setIsLoading(true);
    try {
      const start = Date.now();
      let token = sessionStorage.getItem("key");
      await fetch(
        `${api_host}/reporte/online/indicadores/getUmbrales/?token=${token}&objetivo=${objetivoId}&start=${start}`
      )
        .then((response) => response.json())
        .then((myJson) => {
          if (Array.isArray(myJson.pasos)) {
            setData(myJson.pasos);
          } else {
            setData(null);
          }
        });
    } catch (e) {
      console.error(e);
      setIsError(true);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }

  return { data, isLoading, isError, refetch: fetchPasosObjetivo };
}
